import api from './client';

export async function previewImport(formData) {
  const res = await api.post('/import-export/import/preview', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function executeImport(payload) {
  const res = await api.post('/import-export/import/execute', payload);
  return res.data;
}

export async function getImportHistory() {
  const res = await api.get('/import-export/import/history');
  return res.data;
}

export async function verifyExportStepUp(masterPassword, format) {
  const res = await api.post('/import-export/export/verify-stepup', {
    masterPassword,
    format,
  });
  return res.data;
}
